// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1058":"26013d34f11bd35c","1707":"6e903adf9cfdb7a4","2399":"722ad23c2c1cff6a","8971":"8ac09c0bd23fa075"}[chunkId] + ".css";
};